module.exports = __webpack_public_path__ + "img/504.42f5247a.jpg";